import { render, staticRenderFns } from "./token-details.vue?vue&type=template&id=642d36ec&"
import script from "./token-details.vue?vue&type=script&lang=js&"
export * from "./token-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports